import { FormikProps } from "formik";
import { Input, Modal } from "../../../components";

interface DenyModalProps {
  denyModalVisibility: boolean;
  modalVisibilityControls: {
    setFalse: () => void;
  };
  formik: FormikProps<{ reason: string }>;
}

export const DenyBidsModal = ({ denyModalVisibility, modalVisibilityControls, formik }: DenyModalProps) => {
  return (
    <Modal
      open={denyModalVisibility}
      onClose={modalVisibilityControls.setFalse}
      title="Qual o motivo da recusa?"
      onConfirm={formik.handleSubmit}
      confirmLabel="Confirmar"
    >
      <div
        style={{
          width: 400,
        }}
      >
        <Input
          label="Motivo"
          name="reason"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.reason}
          helperText={formik.touched.reason && formik.errors.reason}
          error={!!formik.touched.reason && !!formik.errors.reason}
        />
      </div>
    </Modal>
  );
};
